<template>
  <b-table :data="totems" narrowed hoverable>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <b-table-column
      field="id"
      :label="$t('totems.totemId')"
      sortable
      v-slot="props"
    >
      {{ props.row.personalInfo.personalId }}
    </b-table-column>

    <b-table-column :label="$t('totems.actions')" v-slot="props" centered>
      <b-tooltip
        :label="$t('totems.loadProducts')"
        position="is-left"
        multilined
      >
        <button
          class="button is-small"
          @click="sendToTotemCommand(props.row, 'update-products')"
        >
          <b-icon icon="edit" type="is-dark"></b-icon>
        </button>
      </b-tooltip>
    </b-table-column>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="sad-cry" size="is-large"></b-icon>
          </p>
          <p>{{ $t("common.tableEmptyMessage") }}</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import { common } from "../../mixins/common";
import { mapGetters } from "vuex";

export default {
  props: ["totems"],

  mixins: [common],

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    sendToTotemCommand(totem, command) {
      this.isLoading = true;
      this.$store
        .dispatch("sendCommandToTotem", {
          totemId: totem._id,
          command: command
        })
        .then(resp => {
          if (resp.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: "Sucesso!",
              message: this.$t("totems.commandSent"),
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa"
            });
          } else {
            this.alertError(resp.data);
          }
        })
        .catch(err => {
          console.error("Error sending command to totem", err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  computed: {
    ...mapGetters(["permissions"])
  }
};
</script>
